<div class="myPurchase-dialog-container">
    <div class="myPurchase-dialog-header">
        Raise Purchase Order (PO)
    </div>
    <div class="myPurchase-dialog-content">
        <p>Please select the vendor to purchase from and the following items will be included in a new PO on MMS.</p>
        <div class="form-inputs">
            <p class="label">Vendor Name</p>
            <!-- <ng-select [items]="vendorListOptions" bindLabel="value" bindValue="id" appearance="outline"
                placeholder="Please select an option" [(ngModel)]="selectedId">
                 <ng-template ng-label-tmp let-item="item">
                    {{ item.Name }} <span *ngIf="isDateExpired(item.QuoteExpiring)">(Quote expired)</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div>{{ item.Name }} <span *ngIf="isDateExpired(item.QuoteExpiring)">(Quote expired)</span></div>
                </ng-template>
            </ng-select> -->
            <ng-select [items]="vendorListOptions" appearance="outline" bindLabel="value" bindValue="id" dropdownPosition="bottom"
                placeholder="Please select an option" [(ngModel)]="selectedId" [appendTo]="'body'">
                <ng-template ng-option-tmp let-item="item">
                    <div [matTooltip]="item.disabled ? 'This vendor has already been raised in an existing PO.' : ''"
                        matTooltipClass="mat-custom-tooltip">{{item.value}}</div>
                </ng-template>
            </ng-select>
            <!-- <ng-template #vendorOptionDisableTemplate>
                <div class="custom-tooltip">
                    <p>
                        This vendor has already been raised in an existing PO.
                    </p>
                </div>
            </ng-template> -->
            <shared-alert [type]="alertType.Error" *ngIf="vendorError">
                <span alert-content>Please note that you are not allowed to raise more than one PO to the same vendor for a
                    single item. For further clarification, please contact PMM Helpdesk (pmmhelpdesk&#64;dsoemail.dso) on OA.
                </span>
            </shared-alert>
        </div>
        <div>
            <app-item-selection-listing [selectionMode]="false" [list]="rfqItems" [mpMmsInformation]="mpMmsInformation" />
        </div>
    </div>
    <div class="myPurchase-dialog-actions">
        <div mat-dialog-actions>
            <app-button class="mar-r-10 large-button" name="Cancel" (click)="handleClose()" />
            <app-button class="large-button" tabindex="0" name="Raise PO" type="flat-button"
                [disabled]="selectedId == null" (click)="handleSubmit()" />
        </div>
    </div>
</div>